import React from 'react';
import Title from '../../title';
import Adds from './add';
import { Grid, Pagination } from 'semantic-ui-react';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import Permission from '../../../functions/permission';
import View from './view';

class Mechine extends React.Component {

  state = {
    data: [],
    pageNumber: 0,
    totalPages: 50,
    boundaryRange: 1,
    siblingRange: 1,
    showEllipsis: true,
    showFirstAndLastNav: true,
    showPreviousAndNextNav: true, menuPermission: []
  }

  componentDidMount() {
    this.menuControl();
  }

  menuControl() {
    let menuPermission = Permission('machine-model', this.props.menus);
    if (menuPermission.view) {
      this.getMachine(1);
    }
    this.setState({ menuPermission })
  }

  handlePaginationChange = (e, { activePage }) => {
    this.getMachine(activePage);
  }

  getMachine = (page) => {
    let context = this;
    this.setState({ load: true, message: 'getting machine!!!' })
    $.ajax({
      type: 'POST',
      data: { 'page': page },
      url: Server()+'machineinfo/get.php',
      success: function(data)
      {
        console.log(data);
        context.setState({ load: false })
        try {
          let totalPages;
          data = JSON.parse(data);
          for (var i = 0; i < data.length; i++) {
            totalPages = data[i].totalPages;
          }
          totalPages = Number(totalPages);
          totalPages = totalPages / 100;
          let roundOff = Math.round( totalPages );
          if (roundOff < totalPages) {
            roundOff++;
          }
          context.setState({ data: data, totalPages: roundOff, pageNumber: page })
        } catch (e) {

        }
      },
      error: function(e)
      {
        console.log(e);
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  update = (data) => {
    this.setState({ data: data });
  }

  render() {
    return (
      <div>
        <Title title='Machine Model' openDrawer={this.props.openDrawer}/>
        { this.state.menuPermission.view ?
          (
            <div>
              <Loading load={this.state.load} message={this.state.message} />
              <div style={{padding: '2%', display: this.state.machineinfoview}}>
                <Grid>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    {
                      this.state.menuPermission.add ?
                      (
                        <Adds viewEdit={this.state.viewEdit} title={'Add Machine'}
                          type="add" getMachine={this.getMachine} machineinfoedit={this.state.machineinfoedit} />
                      ):''
                    }
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <div id='scrolls'>
                      <View menuPermission={this.state.menuPermission} viewEdit={this.state.viewEdit} data={this.state.data}
                        machineinfoedit={this.state.machineinfoedit}
                        update={this.update} getMachine={this.getMachine} />
                    </div>
                    <div align="right">
                      <Pagination
                        activePage={this.state.pageNumber}
                        boundaryRange={this.state.boundaryRange}
                        onPageChange={this.handlePaginationChange}
                        siblingRange={this.state.siblingRange}
                        totalPages={this.state.totalPages}
                        ellipsisItem={this.state.showEllipsis ? undefined : null}
                        prevItem={this.state.showPreviousAndNextNav ? undefined : null}
                        nextItem={this.state.showPreviousAndNextNav ? undefined : null}
                      />
                    </div>
                  </Grid.Column>
                </Grid>
              </div>
            </div>
          ):
          (
            <div>
              <center>You are not allow to access this menu!!!</center>
            </div>
          )
        }
      </div>
    );
  }
}

export default Mechine;
